// src/.../sidebar/TutorSection.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, TextField, Avatar, Card, CardContent } from '@mui/material';

function TutorSection({ value, readOnly = true, onChange }) {
  const rows = [
    { label: 'Nombre',   key: 'tutorNombre'   },
    { label: 'Email',    key: 'tutorEmail'    },
    { label: 'Teléfono', key: 'tutorTelefono' },
  ];

  return (
    <>
      {/* Card: Tutor */}
      <Card variant="outlined" sx={{ mb: 1.5 }}>
        <CardContent>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>Tutor</Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
            {rows.map(({ label, key }) =>
              readOnly ? (
                value?.[key] ? (
                  <Box key={key}>
                    <Typography variant="caption" color="text.secondary">{label}</Typography>
                    <Typography sx={{ mt: .5 }}>{value[key]}</Typography>
                  </Box>
                ) : null
              ) : (
                <TextField
                  key={key}
                  size="small"
                  label={label}
                  value={value?.[key] || ''}
                  onChange={(e) => onChange?.((p) => ({ ...p, [key]: e.target.value }))}
                />
              )
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Card: Asociación (sin campo de logo URL) */}
      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>Asociación</Typography>

          {readOnly ? (
            (value?.asociacion || value?.asociacionLogo) ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Avatar
                  src={value?.asociacionLogo || ''} // solo visual; sin input
                  alt={value?.asociacion || ''}
                  variant="rounded"
                  sx={{ width: 28, height: 28 }}
                />
                <Typography>{value?.asociacion || '—'}</Typography>
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary">—</Typography>
            )
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Avatar
                src={value?.asociacionLogo || ''}
                alt={value?.asociacion || ''}
                variant="rounded"
                sx={{ width: 28, height: 28 }}
              />
              <TextField
                fullWidth
                size="small"
                label="Asociación"
                value={value?.asociacion || ''}
                onChange={(e) => onChange?.((p) => ({ ...p, asociacion: e.target.value }))}
              />
            </Box>
          )}
        </CardContent>
      </Card>
    </>
  );
}

TutorSection.propTypes = {
  value: PropTypes.object,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default TutorSection;
